import React, { Component } from 'react';
import {enableRoleBypass} from './Variables';


class Roles {
	static isLocalDev()
	{
		try{
			return ((window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') && enableRoleBypass === true);
		}
		catch(error){
			return false;
		}
	}
	
	static Can(groupName,menuName,option)
	{
		try
		{
			// Local fallback to keep legacy app usable while role APIs are being repaired.
			if(Roles.isLocalDev()) return true;

			var role = localStorage.getItem('lab_userRoles');
			var roleList = JSON.parse(role);
			if(Object.keys(roleList).length>0)
			{
				var dt = roleList.filter(function(obj){
					return ((obj.groupname==groupName) && (obj.menuname==menuName));
				});
				
				if(dt.length>0)
				{
					var len = dt.length;
					if(len>0)
					{
						var opt = dt[len-1][option];
						return (opt==='1') ? true : false;
					}
					else
					{
						return false;
					}
				}
				else
				{
					return false;
				}
			}
			else
			{
				return false;
			}			
		}
		catch(error)
		{
			console.log(error);
			return false;
		}
	}
	
	static CanMenu(groupName,menuName)
	{
		try
		{
			// Local fallback to keep legacy app usable while role APIs are being repaired.
			if(Roles.isLocalDev()) return true;

			var role = localStorage.getItem('lab_userRoles');
			var roleList = JSON.parse(role);
			if(Object.keys(roleList).length>0)
			{
				var dt = roleList.filter(function(obj){
					return ((obj.groupname==groupName) && (obj.menuname==menuName));
				});
				
				if(dt.length>0)
				{
					return true;
				}
				else
				{
					return false;
				}
			}
			else
			{
				return false;
			}			
		}
		catch(error)
		{
			console.log(error);
			return false;
		}
	}
	
}
export default Roles;